import type { FC } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Typography } from '@material-ui/core';

interface ToolTipProps {
  tooltips: string[];
  label: string;
}

export const ToolTipView: FC<ToolTipProps> = (props) => {
  const { tooltips, label } = props;
  const toolTipValues = [];
  tooltips.forEach((element) => {
    toolTipValues.push(
      <div>
        {element}
      </div>
    );
  });
  return (
    <Tooltip
      title={(
        <>
          {toolTipValues}
        </>
      )}
      placement="top"
      arrow
    >
      <Typography
        sx={{ ml: 1 }}
        style={{ display: 'inline-block', color: 'blue' }}
      >
        {label}
      </Typography>
    </Tooltip>
  );
};
ToolTipView.propTypes = {
  tooltips: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired
};
